import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Checkbox,
  Heading,
  Stack,
  Text,
} from '@chakra-ui/react'
import type { ChangeEvent, Dispatch, SetStateAction } from 'react'

import CourseQ from '@/queries/CourseQ'
import { useQuery } from '@/client/context/query'

import { useQueryCourses, useUpdateSelectedCourses } from '@/components/Explore/helpers'
import Tippy from '@/components/UI/Tippy'

const ExploreCourseFilter: React.FC<{
  disabled: boolean
  setPageDisabled: Dispatch<SetStateAction<boolean>>
}> = ({ disabled, setPageDisabled }) => {
  const query = useQuery()
  const updateSelectedCourses = useUpdateSelectedCourses(setPageDisabled)

  const coursesSelected = new Set(useQueryCourses())

  const courses = query.many(CourseQ.getAll({ excludeOther: true }))

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (disabled) {
      return
    }

    const courseSlug = `${e.target.value}`
    const dupSelectedCourses = new Set(coursesSelected)
    if (e.target.checked === true) {
      dupSelectedCourses.add(`${courseSlug}`)
    } else {
      dupSelectedCourses.delete(`${courseSlug}`)
    }
    updateSelectedCourses(Array.from(dupSelectedCourses))
  }

  return (
    <Accordion defaultIndex={[0]} position="sticky" top="0px" py={3} allowToggle>
      <AccordionItem>
        <Tippy content="Collapse/Uncollapse Courses">
          <AccordionButton
            bgColor="transparent"
            border="none"
            px={0}
            pt={0}
            _hover={{
              cursor: 'pointer',
            }}
            _focus={{
              outline: 'none',
            }}
          >
            <Box flex={1} textAlign="left">
              <Heading size="xl" as="h3" mt="8px" mb="12px">
                Subjects
              </Heading>
            </Box>
            <AccordionIcon />
          </AccordionButton>
        </Tippy>
        <AccordionPanel p={0}>
          <Stack spacing={0}>
            {courses.map(entry => {
              const courseId = entry(CourseQ.id)
              const courseName = entry(CourseQ.name)
              const courseSlug = entry(CourseQ.slug)

              return (
                <Checkbox
                  key={courseId ?? 0}
                  value={courseSlug ?? 0}
                  isDisabled={disabled}
                  onChange={handleChange}
                  p={2}
                  borderRadius="md"
                  _hover={{
                    bgColor: 'bg.subtle',
                  }}
                  isChecked={coursesSelected.has(`${courseSlug}`)}
                  color={coursesSelected.has(`${courseSlug}`) ? 'primary.fg' : 'fg'}
                >
                  <Text as="span">{courseName}</Text>
                </Checkbox>
              )
            })}
          </Stack>
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  )
}

export default ExploreCourseFilter
